<template>
    <div id="mainContainer">
        <!-- PC端头部 -->
        <div class="header hidden-sm-and-down">
            <h1 class="logo-container">
                <img :src="logo" alt="logo" class="logo">
                北京治元景行科技有限公司
            </h1>
            <div class="flex-1"></div>
            <div class="menu">
                <div class="menu-tab" v-for="tab in tabs">
                    <div @click="changeTab(tab)" :class="`tab-name ${activeIndex == tab.path ? 'active' : ''}`">
                        {{ tab.name }}
                    </div>
                </div>
            </div>
            <div class="flex-1"></div>
            <img :src="qrcode" alt="qrcode" class="qrcode">
        </div>
        <!-- 移动端头部 -->
        <el-row class="hidden-md-and-up">
            <el-col :span="24" class=" mobile-index">
                <el-row>
                    <el-col :span="24" class="logo-container-m">
                        <div class="logo-tit-m">
                            <van-image width="0.3rem" height="0.3rem" :src="logo" style="margin-right: 0.1rem;" />
                            <h2 class="tit-m"> 北京治元景行科技有限公司</h2>
                        </div>
                        <van-tabs v-model:active="mobbileActive" title-active-color="#fff" color="#0492b6"
                            title-inactive-color="#a9a9a9" :background="'#000'">
                            <van-tab to="/home" title="首页"></van-tab>
                            <van-tab to="/aboutUs" title="关于我们"></van-tab>
                            <van-tab to="/products/1" title="产品中心"></van-tab>
                            <van-tab to="/solution" title="解决方案"></van-tab>
                            <van-tab to="/cases" title="案例展示"></van-tab>
                            <van-tab to="/support" title="客户服务"></van-tab>
                            <van-tab to="/joinUs" title="加入我们"></van-tab>
                        </van-tabs>
                        <van-image width="0.4rem" height="0.4rem" :src="qrcode" />
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <div class="body-container" :style="`height:${pageHeight - 60}px;width:100%`">
            <router-view />
            <el-row class="hidden-sm-and-down ">
                <el-col :span="24" class="footer-warp">
                    <div class="footer-container">
                        <div class="first-line">
                            <span class="info">
                                <i class="el-icon-message"></i>
                                &nbsp;support@reavenue.com.cn</span>
                            <span class="info">
                                <i class="el-icon-phone-outline"></i>
                                &nbsp;13811317591</span>
                            <span class="info">
                                <i class="el-icon-time"></i>
                                &nbsp;9:00一18:00(周一至周五)</span>
                            <span class="info">
                                <i class="el-icon-map-location"></i>
                                &nbsp;北京市海淀区清河嘉园东区甲一号楼1518</span>
                        </div>
                        <div class="second-line">
                            <h5> Reavenue.com.cn © 2011</h5>
                            <h5> 北京治元景行科技有限公司版权所有</h5>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!-- 移动端 尾部 -->
            <el-row class="hidden-md-and-up">
                <el-col :span="24" class="footer-warp1">
                    <div class="footer-container">
                        <div class="first-line">
                            <span class="info">
                                <i class="el-icon-message"></i>&nbsp;support@reavenue.com.cn</span>
                            <span class="info">
                                <i class="el-icon-phone-outline"></i>&nbsp;13811317591</span>
                            <span class="info">
                                <i class="el-icon-time"></i>&nbsp;9:00一18:00(周一至周五)</span>
                            <span class="info">
                                <i class="el-icon-map-location"></i>&nbsp;北京市海淀区清河嘉园东区甲一号楼1518</span>
                        </div>
                        <div class="second-line">
                            <h5>Reavenue.com.cn © 2011</h5>
                            <h5> 北京治元景行科技有限公司版权所有</h5>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
  
<script>
import logo from '@/assets/logo.png'
import qrcode from '@/assets/logo/qrcode.jpg'
import router from '@/router'
export default {
    name: '',
    data() {
        return {
            logo, qrcode,
            activeIndex: router.currentRoute.path,
            pageHeight: window.innerHeight,
            mobbileActive: '',
            tabs: [
                {
                    path: '/home',
                    name: "首页",
                },
                {
                    path: '/aboutUs',
                    name: "关于我们"
                },
                {
                    path: '/products/1',
                    name: "产品中心"
                },
                {
                    path: '/solution',
                    name: "解决方案"
                },
                {
                    path: '/cases',
                    name: "案例展示"
                },
                {
                    path: '/support',
                    name: "客户服务"
                },
                {
                    path: '/joinUs',
                    name: "加入我们"
                },
            ]
        }
    },
    methods: {
        changeTab(tab) {
            router.push(tab.path)
            this.activeIndex = tab.path
        }
    },
}
</script>
<style lang="scss" scoped>
.header {
    background: #222;
    height: 0.6rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0.2rem;
    color: #fff;

    .logo-container {
        font-size: 0.2rem;
        font-family: Courier New, Courier, monospace;
        height: 0.4rem;
        line-height: 0.4rem;
        min-width: 3rem;

        .logo {
            height: 0.4rem;
            width: 0.4rem;

        }

    }

    .flex-1 {
        flex: 1;
    }

    .menu {
        display: flex;

        .menu-tab {
            min-width: 0.9rem;
            cursor: pointer;
            text-align: center;
            height: 0.6rem;
            line-height: 0.6rem;
            padding: 0 0.1rem 0.02rem;
            margin: 0 0.1rem;

            .tab-name {
                color: #a9a9a9;
                font-size: 0.16rem;
                height: 0.56rem;
                line-height: 0.6rem;

                &:hover {
                    color: #fff;
                }
            }

            .active {
                border-bottom: 2px solid #fff;
            }

            &:hover {
                background: #1b1b1b;
            }


        }
    }

    .qrcode {
        height: 0.5rem;
        min-width: 0.5rem;
    }

}

.mobile-index {
    background: rgba(28, 28, 29, 0.9);

    .logo-container-m {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.1rem;
        color: #fff;
        background: #000;

        .logo-tit-m {
            display: flex;
            align-items: center;

            .tit-m {
                font-size: 0.16rem;
                color: #0492b6;
            }
        }


    }
}

.body-container {
    overflow: auto;
}

.footer-warp {
    background: #222222;
    display: flex;
    justify-content: center;

    .footer-container {
        height: 1rem;
        width: 1200px;

        .first-line {
            color: #fff;
            display: flex;
            justify-content: flex-start;
            height: 0.4rem;
            align-items: center;

            .info {
                margin-right: 80px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 0.14rem;

                .el-icon {
                    font-size: 0.14rem;
                    margin-right: 0.03rem;
                }
            }
        }

        .second-line {
            color: #999;
            font-size: 0.12rem;
            line-height: 0.22rem;

            h5 {
                font-weight: 500;
            }
        }
    }
}

.footer-warp1 {
    background: #222222;
    display: flex;
    justify-content: center;
    padding: 0.1rem;

    .footer-container {
        height: 0.8rem;
        width: 100%;

        .first-line {
            color: #fff;
            display: flex;
            justify-content: flex-start;
            height: 0.4rem;
            align-items: center;
            font-size: 0.16rem;

            .info {
                margin-right: 80px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 0.09rem;

                .el-icon {
                    font-size: 0.2rem;
                    margin-right: 3px;
                }
            }
        }

        .second-line {
            color: #999;
            font-size: 0.14rem;
            line-height: 0.22rem;

            h5 {
                font-weight: 500;
            }
        }
    }
}
</style>
<style lang="scss"></style>
  